<template>
  <div class="goods-index">
    <el-container>
      <el-aside width="200px">
        <el-row class="tac">
          <el-menu
            class="el-menu-vertical-demo"
            router
            :default-active="$route.path"
            :default-openeds="open"
            :unique-opened="true"
            @open="handleOpen"
          >
          
            <el-submenu v-for="(item,index) in side_config" :index="`${index+1}`" :key="index">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{item.cn_name}}</span>
              </template>

              <el-menu-item
                v-for="(v,i) in item.children"
                :key="`${(index+1)-(i+1)}`"
                :index="v.path"
              ><div class='goods-r' :class="path.indexOf(v.path)!=-1?'c-9da':''">{{v.cn_name}}</div></el-menu-item>
            </el-submenu>
          </el-menu>
        </el-row>
      </el-aside>
      <el-main>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="item.index">{{item.cn_name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class='content'>
          <router-view/>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<style scoped>
.title {
  line-height: 100px;
}
.goods-index{
  width:1200px;
  margin:0 auto;
}
.goods-r{
  text-align:right;
}
.c-9da{
  color:#6435E8;
}
</style>

<script>
import side_config from "../../config/side";
export default {
  name: "index",
  data() {
    return {
      open:['1'],
      isvip:'',//1 为普通用户 2为招商人员
      side_config:side_config.home,
      breadcrumb: [],
      path:''
    };
  },
  components: {
  },
  created() {
    this.isvip = this.$http.getAuth("user_info").type;
    if(this.isvip==2){
      this.side_config=side_config.isvip;
    }
  },
  watch: {
    // 对路由变化作出响应...
    $route: {
      handler: function() {
        this.getRout();
      },
      immediate: true
    }
  },
  methods: {
    //默认打开的菜单页
    handleOpen(key,keyPath){
        if(keyPath.length==0){
            this.open=[`${key}`];
        }else{
            this.open=keyPath;
        }
    },
    getRout() {
      let _this = this;
      this.breadcrumb = [];
      let path = this.$route.path;
      this.path=path;
      let a = path.split("/")[1] || "";
      let b = path.split("/")[2] || "";
      let c = path.split("/")[3] || "";
      this.v = this.$http.getAuth("auth_token") ? null : "login";
      // debugger
      side_config.home.forEach((item, index) => {
        // 登陆注册清除缓存
        if (a == "login" || a == "forgot") {
          this.$http.removeAuth();
        }
        if (a == item.name) {
          this.breadcrumb.push({
            cn_name: item.cn_name
          });
          // 2级
          item.children.forEach((v, i) => {
            if (b == v.name) {
              if (b == "subsomeone") {
                this.breadcrumb.push({
                  cn_name:
                    sessionStorage.getItem("setType") == 1
                      ? v.cn_name
                      : "修改单品"
                });
              } else {
                this.breadcrumb.push({
                  cn_name: v.cn_name
                });
              }
            }
            if (v.children) {
              v.children.forEach((m, n) => {
                if (c == m.name) {
                  this.breadcrumb.push({
                    cn_name: m.cn_name
                  });
                }
              });
            }
          });
        }
      });
       console.log(this.breadcrumb)
    }
  }
};
</script>
